import { render, staticRenderFns } from "./DeArchiveButton.vue?vue&type=template&id=09f4e924&scoped=true"
import script from "./DeArchiveButton.vue?vue&type=script&lang=ts"
export * from "./DeArchiveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f4e924",
  null
  
)

export default component.exports